import { Link, useLocation } from 'react-router-dom';
import './Navbar.scss';
import { useEffect, useState } from 'react';

const sections = [
    { id: "about", name: "About" },
    { id: "projects", name: "Work" },
    { id: "contact", name: "Connect" }
];

function Navbar() {

    const [isGlass, setIsGlass] = useState(false);
    const [activeSection, setActiveSection] = useState<string | null>(null);
    const location = useLocation();
    const isHome = location.pathname === "/";

    useEffect(() => {
        const onScroll = () => {
            setIsGlass(window.scrollY > 100);
            if (window.scrollY < 400) {
                setActiveSection(null);
            }
        };

        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setActiveSection(entry.target.id);
                    }
                });
            },
            {
                root: null,
                rootMargin: '-30% 0px -55% 0px',
                threshold: 0,
            }
        );

        sections.forEach(section => {
            const el = document.getElementById(section?.id);
            if (el) observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <nav className={`navigation ${isGlass ? "glass" : ""}`}>
            <div className="container">
                <div className="logo">
                    <Link to={'/'}>
                        <img src='/ms-logo.webp' alt='ms-logo' />
                    </Link>
                </div>
                {
                    isHome ? (
                        <div className="navLinks">
                            {sections.map(section => (
                                <a
                                    key={section.id}
                                    href={`#${section.id}`}
                                    className={`navLink ${activeSection === section.id ? 'active' : ''}`}
                                >
                                    {section?.name}
                                </a>
                            ))}
                        </div>
                    ) :
                    (
                            <div className="navLinks">
                                <Link to={'/'}>
                                ← Back
                                </Link>
                        </div> 
                    )
                }

            </div>
        </nav>
    )
}

export default Navbar;